import { FC } from 'react'
import { AutoComplete, TextField } from '@microservices/wiskey-react-components'
import { Box } from '@mui/material'

import { generalFieldStylesByMode, getAutoCompletePopperSxByDisplayMethod } from '@helpers'
import { AutocompleteOption } from '@types'

interface SearchAssistantDailyRangeDatePickerProps {
  autocompleteOptionsDailyRange: AutocompleteOption<string | number>[]
  dailyRangeValue: AutocompleteOption | null
  isSearchAssistantDialogWindow?: boolean
  handleChangeDailyRange: (value: AutocompleteOption) => void
  disabled?: boolean | undefined
}

const SearchAssistantDailyRangeDatePicker: FC<SearchAssistantDailyRangeDatePickerProps> = props => {
  const {
    autocompleteOptionsDailyRange,
    handleChangeDailyRange,
    dailyRangeValue,
    isSearchAssistantDialogWindow,
    disabled,
  } = props

  return (
    <AutoComplete
      disableClearable
      fullWidth
      disabled={disabled}
      // isOptionEqualToValue={(option, value) => option.label === value.label}
      options={autocompleteOptionsDailyRange}
      size='small'
      // value={(value || { id: '', label: '' }) as AutocompleteOption}
      value={dailyRangeValue}
      componentsProps={{
        popper: {
          sx: {
            zIndex: theme => theme.zIndex.tooltip,
            ...getAutoCompletePopperSxByDisplayMethod(isSearchAssistantDialogWindow),
          },
        },
      }}
      renderInput={params => (
        <TextField
          {...params}
          sx={theme => ({
            ...generalFieldStylesByMode(
              // @ts-expect-error TODO(isilanov): fix type for theme
              theme,
              undefined,
              undefined,
              undefined,
              isSearchAssistantDialogWindow
            ),
          })}
        />
      )}
      renderOption={(props, option) => {
        const { key, ...restProps } = props

        return (
          <li key={key} {...restProps} title={option.label}>
            <Box sx={{ overflowX: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {option.label}
            </Box>
          </li>
        )
      }}
      onChange={handleChangeDailyRange}
    />
  )
}

export { SearchAssistantDailyRangeDatePicker }
